import { render, staticRenderFns } from "./RoleConfirmation.vue?vue&type=template&id=7f141063&"
import script from "./RoleConfirmation.vue?vue&type=script&lang=js&"
export * from "./RoleConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports